import event1 from "../../images/event-1.png"
import event2 from "../../images/event-2.png"
import event3 from "../../images/event-3.png"
import event4 from "../../images/event-4.png"
import event5 from "../../images/event-5.png"
import event6 from "../../images/event-6.png"
import event7 from "../../images/event-7.png"
import event8 from "../../images/event-8.png"
import event9 from "../../images/event-9.png"
import arroew from "../../images/normalarrow.png"
import hoverArrow from "../../images/hoverarrow.png"

export const EventData = [
    {
        id : 1,
        title : "Tournment Indoor Court Women’s Basketball",
        img : event1,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 2,
        title : "Twenty Minutes Still Meditation in Bond ",
        img : event2,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 3,
        title : "Art Exhibit Student Chairs   by Design Student",
        img : event3,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 4,
        title : "Get The Best Courses & Upgrade Your Skills",
        img : event4,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 5,
        title : " Applying Natural Laws to Technology and Society ",
        img : event5,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 6,
        title : "SAT Implementation Workshops Dec 2022",
        img : event6,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 7,
        title : "National Capital Leadership Jan 2023",
        img : event7,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 8,
        title : "Digital Transformation Conference",
        img : event8,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
    {
        id : 9,
        title : "Best Technology Graduation Ceremony.",
        img : event9,
        arrowbtn : arroew,
        hoverbtn : hoverArrow
    },
]